





























































import { defineComponent, reactive, toRefs, onMounted, ref, watch } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue"
import { BTable } from 'bootstrap-vue';
import { SaitenCount, SearchCondition } from "../../modules/teacher/SaitenCountDownload"

export interface Data {
  condition: SearchCondition
  saitenCounts: SaitenCount[]
  isAllCheckDownload: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      saitenCounts: [],
      isAllCheckDownload: false,
      errors: [],
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = async () => {
      await search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {

      state.errors = []

      if(!state.condition.submitted_at_from && !state.condition.submitted_at_to && !state.condition.result_published_at_from && !state.condition.result_published_at_to){
        state.errors.push("提出日期間、公開日期間いずれかを入力してください。");
      }else{
        if((state.condition.submitted_at_from || state.condition.submitted_at_to) && (!state.condition.submitted_at_from || !state.condition.submitted_at_to)){
          state.errors.push("提出日期間で検索する場合は開始日・終了日を入力してください。");
        }

        if((state.condition.result_published_at_from || state.condition.result_published_at_to) && (!state.condition.result_published_at_from || !state.condition.result_published_at_to)){
          state.errors.push("公開日期間で検索する場合は開始日・終了日を入力してください。");
        }
      }

      // 入力エラーは処理終了
      if(state.errors.length > 0){
        return;
      }

      if(!window.confirm("採点実績情報をダウンロードします。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/saiten_count_download?${Common.BuildQuery(state.condition, 'search_condition')}`).then(async response => {
        state.saitenCounts = response.data.saiten_counts.map((x: any) => new SaitenCount(x));
        if(state.saitenCounts.length == 0){
          alert("条件に一致するデータはありませんでした。");
        }else{
          let csvData = '';

          const header = [];
          if(state.condition.is_group_scored_user_name){
            header.push("採点者");
          }
          header.push("レポートID");
          header.push("科目CD");
          header.push("科目名");
          header.push("レポートNO");
          if(state.condition.is_group_student){
            header.push("生徒名");
          }
          header.push("枚数");
          csvData += header.join(',') + '\r\n';

          state.saitenCounts.forEach(x => {
            const cols = [];
            if(state.condition.is_group_scored_user_name){
              cols.push(x.scored_user_name);
            }
            cols.push(x.sheet_code);
            cols.push(x.subject_code);
            cols.push(x.subject_name);
            cols.push(x.report_no);
            if(state.condition.is_group_student){
              cols.push(x.student_name);
            }
            cols.push(x.saiten_count);
            csvData += cols.join(',') + '\r\n';
          });

          const link = document.createElement('a');
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
          let blob: any = null;
          const csvName = `採点実績_${moment().format("YMD")}`;

          if (window.navigator.msSaveOrOpenBlob) {
            // for ie
            blob = new Blob([bom, csvData], {type: 'text/csv'});
            window.navigator.msSaveOrOpenBlob(blob, csvName);
          } else if (window.webkitURL && window.webkitURL.createObjectURL) {
            // for chrome (and safari)
            blob = new Blob([bom, csvData], {type: 'text/csv'});
            link.setAttribute('download', csvName);
            link.setAttribute('href', window.webkitURL.createObjectURL(blob));
            link.click();
          } else if (window.URL && window.URL.createObjectURL) {
            // for firefox
            blob = new Blob([bom, csvData], {type: 'text/csv'});
            link.setAttribute('download', csvName);
            link.setAttribute('href', window.URL.createObjectURL(blob));
            link.click();
          }
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      // await search();
    });

    return {
      ...toRefs(state),
      tableRef,
      searchClick,
      search,
      clearCondition,
    };
  }
});
